<template>
  <div v-if="data.open" class="info-block">
    <div class="card">
      <button @click="data.open = false" type="button" class="btn btn-default closeBtn"><i
        class="icon-fa icon-fa-remove"></i>
      </button>
      <div class="card-header bg-primary">
        <h5>Запрос на звонок клиенту с сайта! (25 секунд)</h5>
      </div>
      <div class="card-body">
        <p>Запрос с проекта <span class="badge badge-info fs-14">{{ $AllProjects[data.data.api_site_id]?.title }}</span>
        </p>
        <p>телефон: <strong class="fs-14">{{ data.data.phone }}</strong></p>
        <p v-if="data.data.client_black_list"><span class="badge badge-danger">Черный список</span></p>
        <p v-if="data.data.drug_id">{{ data.data.drug_id }}</p>
        <p class="fs-18" v-if="data.data.drug">{{ data.data.drug.title }}</p>
        <p v-if="data.data.page">страница: <a target="_blank" :href="data.data.page">{{ data.data.page }}</a></p>
        <div class="mt-1 text-right">
          <button @click="createOrder" type="button" class="btn btn-success btn-xs">Создать заявку с текущим клиентом
          </button>
        </div>
        <hr>
        <template v-if="phoneNum && sip">
          <p>Совершить звонок с номера: <strong>{{ phoneNum.connected_phone.display_phone }}</strong> ({{ phoneNum.connected_phone.description}})</p>
          <p>SIP: {{ sip.sip_login }}</p>
          <div class="mt-1 text-right">
            <LoadingButton
              title="Позвонить"
              type="button"
              :loading="btnLoading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => makePhoneCall()"
              className="btn btn-outline-success"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import {fillOrderBus} from "@/eventsBus";

export default {
  components: {LoadingButton},
  props: ['data'],
  data() {
    return {
      btnLoading: false,
      phoneNum: null,
      sip: null,
    }
  },
  computed: {
    $userPhones() {
      return this.$store.getters["user/phoneNumbers"];
    },
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce(
        (acc, p) => {
          acc[p.id] = {...p}
          return acc
        }, {});
    },
  },
  created() {
    this.data.data = JSON.parse(this.data.data);
    // console.log(this.$userPhones.phoneNumbers, this.data.data);
    this.phoneNum = this.$userPhones.phoneNumbers.find((p) => p.connected_phone?.site_id === this.data.data.api_site_id && p.connected_phone.city_id === 1);
    if (!this.phoneNum) this.phoneNum = this.$userPhones.phoneNumbers.find((p) => p.connected_phone?.site_id === this.data.data.api_site_id && !p.connected_phone.city_id);
    if (!this.phoneNum) this.phoneNum = this.$userPhones.phoneNumbers.find((p) => !p.connected_phone?.site_id && !p.connected_phone.city_id);
    if (!this.phoneNum) this.phoneNum = this.$userPhones.phoneNumbers.find((p) => !p.connected_phone?.site_id);
    if (!this.phoneNum) {
      toastr['warning']('Нет номера телефона для совершения звонка', 'Ошибка');
      return;
    }
    this.sip = this.$userPhones.sipAccounts.find((s) => s.acc_id === this.phoneNum.connected_phone.service_id);
  },
  methods: {
    createOrder() {
      // console.log(this.$route.name);
      const data = {
        // client: this.data.client,
        phoneNum: this.data.data.phone,
        phoneCallId: this.data.data.mango_call_id,
        drugId: this.data.data.drug_id,
        extra_data: {
          city_id: 0,
          project_id: this.data.data.api_site_id,
          mirror_id: null,
        }
      };
      console.log(data);
      if (this.$route.name === 'newOrder') {
        fillOrderBus.$emit(
          'updateFillOrder',
          data
        );
      } else {
        this.mixinGoToRouter("newOrder", data);
      }
    },
    async makePhoneCall() {
      this.btnLoading = true;
      const {data} = await api.post("/telephony/makePhoneCall2", {
        mango_phone_id: this.phoneNum.phone_id,
        sip: this.sip.id,
        phone: this.data.data.phone,
        mango_call_id: this.data.data.mango_call_id,
        command: this.data.data.mango_call_id,
      });
      if (data.success) {
        toastr['success']('Звонок создан', 'Успешно!');
        // this.data.open = false;
      } else {
        toastr['warning'](data.message ?? 'Сервер не ответил', 'Ошибка!');
      }
      this.btnLoading = false;
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 2px;
}

.closeBtn {
  z-index: 9;
  position: absolute;
  top: 10px;
  right: 10px;
}

.closeBtn i {
  text-align: center;
}

.info-block .card {
  background-color: #f7f6f6;
  -webkit-box-shadow: 2px 2px 15px -5px #000000;
  box-shadow: 2px 2px 15px -5px #000000;
}
</style>
